import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar, faQrcode, faMedal, faClockFour, faListUl } from '@fortawesome/free-solid-svg-icons';
import './WalkingJoy.css';
import walkingjoyimage from '../../assets/pageimages/WalkingJoy.webp';

function WalkingJoyHome() {

  return (
    <MainLayout>
      <div>
        <h2 className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>WalkingJoy</h2>
      </div>
      <div className="main-content">
        <div className="top-section top-section mt-4 ml-2 mr-0 border border-b-gray-300">
          <div className="button-links flex align-middle justify-center bg-gray-500">
            <div className="bottom-buttons-box"><Link to="/walkingjoy-history" className="top-button-link"><FontAwesomeIcon icon={faListUl} className="walkingjoy-bottomlink-style" />History</Link></div>
            <div className="bottom-buttons-box"><Link to="/walkingjoy-scan" className="top-button-link"><FontAwesomeIcon icon={faQrcode} className="walkingjoy-bottomlink-style" />Scan</Link></div>
            <div className="bottom-buttons-box"><Link to="/walkingjoy-chronicles" className="top-button-link"><FontAwesomeIcon icon={faClockFour} className="walkingjoy-bottomlink-style" />Chronicles</Link></div>
            <div className="bottom-buttons-box"><Link to="/walkingjoy-gifts" className="top-button-link"><FontAwesomeIcon icon={faMedal} className="walkingjoy-bottomlink-style" />Gifts & Prizes</Link></div>
          </div>
        </div>
        <div className="image-container">
          <div className="relative inset-0 flex border border-b-gray-300">
            <img id="walkingjoy-id" src={walkingjoyimage} alt="WalkingJoy Image" />
          </div>
        </div>
      </div>
    </MainLayout>
  );
}

export default WalkingJoyHome;
